module.exports = __webpack_public_path__ + "img/InstagramIcon.9bd3d758.svg";